import { ReactNode } from "react";

export function extractTextFromNode(node: ReactNode): string {
  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(extractTextFromNode).join("");
  }
  if (node && typeof node === "object" && "props" in node) {
    return extractTextFromNode((node as any).props.children);
  }
  return "";
}
